export const entity = require('../../../../utils/entityJoin').joinEntities(
    {
        name: 'AxisAndMesh',
        fields: [
            'name',
        ],
        filters: [
            {
                name: 'byIncludeInFunctionScope',
                isDefault: true,
                match: object => {
                    if(object.joinedEntity === 'OrganizationalAxis') {
                        return object.includeInFunctionScope
                    }
                    return true
                }
            }
        ]
    },
    ['OrganizationalAxis', 'Mesh']
)
